import { getSize, getWeight } from "views/resources/theme";
import { hiddenWrap } from "./utils";
import styled from "styled-components";

export const CollapseHeader = styled.button`
	border: none;
	display: flex;
	align-items: center;
	height: 64%;
	padding: 8px 16px 0;	
	width: 100%;
	background: #FFF;
	color: #000;
	cursor: pointer;

	h3 {
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		margin: 0;
		color: #000;
		font-size: 14px;
		font-weight: 500;
	}
`;

export const Wrap = styled.div`
	.collapse-css-transition {
		transition: height 280ms cubic-bezier(0.4, 0, 0.2, 1);
		width: 100%;
	}
	${hiddenWrap}
`;
